import { render, staticRenderFns } from "./SettledDigua.vue?vue&type=template&id=412b0196&scoped=true"
import script from "./SettledDigua.vue?vue&type=script&lang=js"
export * from "./SettledDigua.vue?vue&type=script&lang=js"
import style0 from "./SettledDigua.vue?vue&type=style&index=0&id=412b0196&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412b0196",
  null
  
)

export default component.exports